import React from 'react'
import '../scss/components/section.scss'
import Header from '../components/header/header.jsx'
import Footer from '../components/footer/footer-v1/index.jsx'
import dataFooter from '../assets/fake-data/data-footer.js'
import Bottom from '../components/bottom/index.jsx'

function UsageLimits(props) {
    return (
        <div className='wrapper-style sv2-tnc-prvcy' id='wrapper'>
            {<Header />}
            <div className='sellagen-fact'>
                <h2 className="sellagen-fact-title"><strong>Usage Limits & Best Practices</strong></h2>
                <br/>

                <p>The number of requests (tokens) you can use in Nelima depends on your plan. The Free plan includes a limited token budget and basic features, while the Pro plan offers a much higher usage cap and advanced capabilities. Factors that affect your usage include components such as input length, file size, conversation history, and use of tools or memory. In general, longer inputs and larger files consume more tokens.</p>
                <br/>
                <p>Nelima's usage limit is measured in tokens. Plan ahead by learning your token budget and crafting prompts accordingly. Try to combine related tasks into one query when possible, this reduces the total number of round-trips needed to complete a job.</p>
                <br/><br/>

                {/* ## 1. MAKE THE MOST OF YOUR USAGE */}

                <h3 className='fs-20 text-color-4'>1. Make the most of your usage</h3>
                <br/>

                <p>Before starting, identify exactly what you need. Write clear, specific instructions to minimize back-and-forth. Consider bundling related questions into a single request (e.g. "List five topics and then give a brief summary of each" instead of five separate queries). Planning tasks carefully can dramatically cut token use.</p>
                <br/><br/>

                {/* ## 2. BE CONCISE AND EXPLICIT */}

                <h3 className='fs-20 text-color-4'>2. Be concise and explicit</h3>
                <br/>

                <p>Ambiguous or vague prompts may require clarification and extra messages. Provide all necessary context up front. For example, if asking Nelima to edit text, include the entire text in one prompt rather than in pieces. Clear, detailed instructions reduce misunderstandings and avoid wasted tokens on clarifying questions.</p>
                <br/>
                <p>When possible, reference earlier content instead of pasting it again. Nelima remembers context within a conversation, so you can say "Access the March invoices stored on the storage and…" rather than repeating information, saving tokens.</p>
                <br/><br/>

                {/* ## 3. USE SCALE MODE EFFECTIVELY */}

                <h3 className='fs-20 text-color-4'>3. Use scale mode effectively</h3>
                <br/>

                <p>Nelima's Scale Mode is designed for long-running, multi-step tasks. On the Free plan, Scale Mode is standard: it handles normal-length tasks but may cut off very long sessions. The Pro plan's extended Scale Mode lets Nelima continue for much longer (for example, several hours or more) by automatically breaking tasks into chunks. Use this when you have a complex task with many steps.</p>
                <br/><br/>

                {/* ## 4. LEVERAGE INTERNET ACCESS WISELY */}

                <h3 className='fs-20 text-color-4'>4. Leverage Internet Access Wisely</h3>
                <br/>

                <p>Nelima includes web browsing for live data. Free accounts have limited browsing. Pro accounts get unlimited browsing for real-time information. Use the browsing feature when you need current events, data, or specific info from the web.</p>
                <br/>
                <p>When browsing, provide precise URLs or keywords to focus the search and avoid excess queries. Remember each webpage read counts toward tokens, so be targeted.</p>
                <br/><br/>

                {/* ## 5. COLLABORATE WITH MULTI-AGENT TASK SHARING (PRO) */}

                <h3 className='fs-20 text-color-4'>5. Collaborate with multi-agent task sharing (Pro)</h3>
                <br/>

                <p>Pro users can enable Multi-Agent Task Sharing, where multiple AI agents work together. This is ideal for complex, multi-faceted tasks. In a multi-agent approach, different specialized agents can handle subtasks in parallel or sequence. For example, one agent might gather data while another analyzes it.</p>
                <br/>
                <p>Keep in mind each agent's interaction uses tokens, so parallel work may consume more tokens overall, but often yields faster and more robust results for complex projects.</p>
                <br/><br/>

                {/* ## 6. ENTITY INTELLIGENCE (PRO) */}

                <h3 className='fs-20 text-color-4'>6. Entity intelligence (Pro)</h3>
                <br/>

                <p>The Pro plan includes Entity Intelligence, which automatically finds and enriches contact information for leads (names, emails, phone numbers, etc.). Use this for lead generation, market research, or sales outreach. For example, give Nelima a company name and role, and it can search databases to return likely contacts.</p>
                <br/>
                <p>Always provide clear filters (industry, location, etc.) to focus results. Because contact data changes, entity searches benefit from recent web access. Also use Entity Intelligence to clean or verify existing lists. Handle personal data responsibly and respect privacy guidelines when using this feature.</p>
                <br/><br/>

                {/* ## 7. BATCH TASKS AND USE SCHEDULED AUTOMATIONS */}

                <h3 className='fs-20 text-color-4'>7. Batch tasks and use scheduled automations</h3>
                <br/>

                <p>Group similar tasks into one session. For example, if you have 5 related queries, ask them together in one prompt instead of 5 separate prompts. This reduces overhead.</p>
                <br/>
                <p>Nelima lets you schedule up to 5 automations on the Free plan and up to 20 on the Pro plan. You will be able to run tasks at set times (daily reports, data fetches, etc.). Use these to automate routine work. For instance, set an automation to scrape web stats every morning.</p>
                <br/><br/>

                {/* ## 8. WORKING WITH THE AGENTIC STORAGE AND FILES */}

                <h3 className='fs-20 text-color-4'>8. Working with the Agentic Storage and Files</h3>
                <br/>

                <p>Nelima's agentic storage functions like a memory or knowledge base. Upload core documents, datasets, or notes to storage so agents can refer to them without you resending them each time. In practice, start a project by storing all reference materials.</p>
                <br/>
                <p>Similarly, manage file processing carefully. The Free plan can read shorter documents; Pro supports very large files. Even on Pro, limit how much of a large document you ask Nelima to output at once.</p>
                <br/><br/>

                {/* ## 9. MONITOR YOUR USAGE AND STORAGE */}

                <h3 className='fs-20 text-color-4'>9. Monitor your usage and storage</h3>
                <br/>

                <p>Keep an eye on your token consumption. If you feel that you're nearing the limit, pause to upgrade plan or adjust usage. Also watch your agentic storage usage (e.g. 5 GB vs 20 GB) to avoid running out of space. Cleaning up old projects or unused files can free storage. Proactively monitoring usage helps prevent unexpected cutoffs.</p>
                <br/><br/>

                <p>By following these guidelines, planning prompts, being concise, and leveraging Nelima's advanced features. You'll make the most efficient use of your tokens and agents. With careful prompting and the right features, Nelima can handle even demanding workloads without hitting limits.</p>
                <br/><br/>

            </div>
            {<Footer data={dataFooter}/>}
            {<Bottom classection='widget-social-footer'/>}
        </div>
    )
}

export default UsageLimits